<template>
	<div class="grid gap-4">
		<FormKit
			type="select"
			name="source"
			:options="bronOptions"
			label="Bron"
			placeholder="Kies..."
		/>
		<FormKit type="textarea" name="description" label="Omschrijving" />
		<FormKit type="loanlinkDate" name="endDate" label="Einddatum" />
		<FormKit
			type="loanlinkCurrency"
			name="grossYearlyPayment"
			label="Bruto bedrag per jaar"
		/>
		<FormKit
			type="loanlinkPercentage"
			name="percentageCounted"
			label="Percentage meetellen voor toetsinkomen"
		/>
	</div>
</template>

<script lang="ts" setup>
import type { InventarisationSelectOption } from "@/models/inventarisation/InventarisationSelectOption";
import type { OverigIncomeBronType } from "@loanlink-nl/model-app";

const bronOptions: InventarisationSelectOption<OverigIncomeBronType>[] = [
	{ label: "Box 2", value: "03 BoxTwee" },
	{ label: "Partneralimentatie", value: "06 Partneralimentatie" },
	{ label: "Kinderalimentatie", value: "07 Kinderalimentatie" },
	{ label: "Schenking", value: "02 Schenking" },
	{ label: "Inkomsten uit verhuur", value: "08 Inkomsten uit verhuur" },
	{
		label: "Resultaat uit overige werkzaamheden",
		value: "09 Resultaat uit overige werkzaamheden",
	},
	{ label: "Anders", value: "99 Anders" },
];
</script>
